export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleServiceClick = (serviceId: string) => {
    const element = document.getElementById(serviceId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-cyan-400">
              Systematic Marketing
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Turning chaos into a system. Combining expert experience with the precision of AI algorithms.
            </p>
            <div className="flex gap-4">
              <a href="https://t.me/+79267899290" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-telegram-line text-xl"></i>
              </a>
              <a href="https://vk.com/sharovairinas" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer p-2">
                <img src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/67a888ef3cc2b2235c0effc4b8ea0be2.png" alt="VKontakte" className="w-full h-full object-contain" />
              </a>
              <a href="https://tenchat.ru/IrinaSharova_marketing?utm_source=acc30d66-2a11-43a2-8f71-6799ce061e61" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer p-2">
                <img src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/ceaec60262df5e2627173dae051e58c0.png" alt="TenChat" className="w-full h-full object-contain" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => handleServiceClick('service-digital-360')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Digital Marketing 360°
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-complex-strategy')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Comprehensive Strategy
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-consulting')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Marketing Consulting
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-partnership')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Strategic Management
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-ozon')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Marketplace Consulting
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-standard')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Contextual Advertising
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-standard')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Targeted Advertising
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-standard')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  SMM: Content and Management
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleServiceClick('service-standard')}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-left"
                >
                  Creating Selling Websites
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-bold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#cases" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contacts</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <a href="tel:+79267899290" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                    +7 (926) 789-92-90
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <a href="mailto:info.unitycore@unitycore.ru" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                    info.unitycore@unitycore.ru
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-telegram-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <a href="https://t.me/+79267899290" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                    Telegram
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-cyan-400 text-xl mt-1"></i>
                <div>
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=109202,+Moscow,+2nd+Karacharovskaya+str.,+1+bld.+1" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    109202, Moscow, 2nd Karacharovskaya str., 1 bld. 1, room 6/2
                  </a>
                </div>
              </li>
            </ul>

            {/* Google Map */}
            <div className="mt-6 rounded-lg overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2247.8!2d37.7!3d55.73!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTXCsDQzJzQ4LjAiTiAzN8KwNDInMDAuMCJF!5e0!3m2!1sen!2sru!4v1234567890!5m2!1sen!2sru&q=109202,+Moscow,+2nd+Karacharovskaya+str.,+1+bld.+1"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Our office on the map"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Systematic Marketing. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
